export class Unauthenticated extends Error {}
